import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=cb83cbf6&scoped=true&"
import script from "./PaymentsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=cb83cbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb83cbf6",
  null
  
)

export default component.exports